import { Link } from "react-router-dom";
import { Wordmark } from "./Brand";
import { WaitlistForm } from "./Layout";
import Pipeline from "./Pipeline";
import { CHANNELS, COMPANY, COMPANY_URL, CONTACT_EMAIL, WAVE_STATUS } from "./content";

/* What visitors see while maintenance is on: the same calm console look as
   the landing page, the pipeline as proof, and the waitlist. */
export default function Maintenance({ platform }) {
  const message = platform?.maintenance_message
    || "We're opening in waves. Leave your email and we'll tell you the moment your workspace is ready.";
  return (
    <div className="min-h-screen bg-ac-bg text-ac-text flex flex-col">
      <header className="border-b border-ac-border">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-8 h-16 flex items-center justify-between">
          <Wordmark />
          <Link to="/login" className="text-[14px] text-ac-text hover:text-ac-link">Sign in</Link>
        </div>
      </header>

      <main className="flex-1 flex items-center">
        <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-8 py-16 grid gap-12 lg:grid-cols-12 lg:items-center">
          <div className="pointer-events-none absolute inset-0 -z-0" aria-hidden="true"
            style={{ background: "radial-gradient(55% 60% at 85% 30%, rgba(99,102,241,0.10), transparent 70%)" }} />
          <div className="relative lg:col-span-7">
            <p className="mono-label text-ac-link">{WAVE_STATUS || "Private beta"}</p>
            <h1 className="mt-5 font-display text-[44px] sm:text-[64px] font-semibold leading-[1.02] tracking-tight">
              Your content team,<br className="hidden sm:block" /> on autopilot.
            </h1>
            <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-ac-muted">{message}</p>
            <div className="mt-8"><WaitlistForm compact /></div>
            <p className="mt-6 mono-label text-ac-muted">Publishes to {CHANNELS.publishes.join(" · ")}</p>
          </div>
          <div className="relative lg:col-span-5"><Pipeline /></div>
        </div>
      </main>

      <footer className="border-t border-ac-border">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-8 py-6 flex flex-col sm:flex-row gap-3 justify-between text-[13px] text-ac-muted">
          <span>
            © {new Date().getFullYear()} AutoCruise, a product of{" "}
            <a href={COMPANY_URL} target="_blank" rel="noreferrer" className="hover:text-ac-text">{COMPANY}</a>
            {" · "}<a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-ac-text">{CONTACT_EMAIL}</a>
          </span>
          <span className="flex gap-5">
            <Link to="/security" className="hover:text-ac-text">Security</Link>
            <Link to="/status" className="hover:text-ac-text">Status</Link>
            <Link to="/privacy" className="hover:text-ac-text">Privacy</Link>
            <Link to="/terms" className="hover:text-ac-text">Terms</Link>
          </span>
        </div>
      </footer>
    </div>
  );
}
